import { UtilsConst } from '@/constants'
import { StoreConst } from '@/store/constants'
import { apiRequest } from '@/store/modules/ApiRequestHelper'
import { CreateMultipleInvitePayload, CreateSingleInvitePayload, ResendInvitePayload } from '@/store/modules/invites/types'
import { TenantHelpers } from '@/utils/tenant-helpers'

declare var consoleLog: any

const invitesV1Url = `/invites/v1`
const invitesV1BulkV1Url = `${invitesV1Url}/bulk/v1`

export default {
  createSingle(context: any, payload: CreateSingleInvitePayload) {
    if (context.rootState.app.myTenantIndex === TenantHelpers.InvalidTenantIndex) {
      return Promise.reject('Invalid Tenant Index')
    }
    const myTenant = context.rootState.app.myTenants[context.rootState.app.myTenantIndex]
    if (myTenant === null || myTenant.ID <= 0) {
      return Promise.reject('Invalid Tenant ID')
    }

    const requestPayload = {
      Invitation: {
        id: 0,
        inviteeEmail: payload.email,
        inviterUserID: this.authService().uid,
        tenantID: myTenant.ID,
        resources: [
          {
            resourceID: payload.resourceID,
            resourceHashID: payload.resourceHashID,
            type: payload.resourceType,
            permActions: payload.permActions,
          },
        ],
        app: 'jigspace',
      },
    }
    context.commit('setCreateResponse', {})
    return apiRequest(
      {
        action: UtilsConst.HTTPAction.POST,
        url: invitesV1Url,
        body: requestPayload,
      },
      context,
      'setCreateResponse',
      `creating invitation`,
      StoreConst.StoreHelper.loadingModalMutationName,
      {
        [UtilsConst.RequestHeaders.CustomHeaderKeyTenantId]: myTenant.ID,
      }
    )
  },

  createBulk(context: any, payload: CreateMultipleInvitePayload) {
    if (context.rootState.app.myTenantIndex === TenantHelpers.InvalidTenantIndex) {
      return Promise.reject('Invalid Tenant Index')
    }
    const myTenant = context.rootState.app.myTenants[context.rootState.app.myTenantIndex]
    if (myTenant === null || myTenant.ID <= 0) {
      return Promise.reject('Invalid Tenant ID')
    }

    // Loop over all requests and make sure tenant ID set
    for (const req of payload.requests) {
      if (req.invitation.tenantID === TenantHelpers.InvalidTenantID) {
        req.invitation.tenantID = myTenant.ID
      }
    }

    context.commit('setCreateBulkResponse', {})
    return apiRequest(
      {
        action: UtilsConst.HTTPAction.POST,
        url: invitesV1BulkV1Url,
        body: payload,
      },
      context,
      'setCreateBulkResponse',
      `creating bulk invitations`,
      StoreConst.StoreHelper.loadingModalMutationName,
      {
        [UtilsConst.RequestHeaders.CustomHeaderKeyTenantId]: myTenant.ID,
      },
      (context: any, error: any, errorMsg: string, onApiCatchError: any) => {
        if (error.response != null && error.response.data != null && error.response.data.Responses != null) {
          context.commit('setCreateBulkResponse', error.response.data)
        } else {
          // Use default error handler
          onApiCatchError(context, error, errorMsg)
        }
      }
    )
  },

  async resendInvite(context: any, payload: ResendInvitePayload) {
    const result: any = {}
    const invitesV1ResendV1Url = `${invitesV1Url}/${payload.inviteId}/resend/v1`
    let tenantId: number = TenantHelpers.InvalidTenantID

    if (payload.tenantId != null && payload.tenantId !== TenantHelpers.InvalidTenantID) {
      tenantId = payload.tenantId
    } else {
      const myTenant = context.rootState.app.myTenants[context.rootState.app.myTenantIndex]

      if (myTenant === null || myTenant.ID <= 0) {
        result.isSuccessful = false
        result.error = {
          inviteId: payload.inviteId,
          message: 'Invalid tenant ID, or tenant ID is not provided.',
        }
        consoleLog('Invalid tenant ID or tenant ID is not provided.')

        return result
      }

      tenantId = myTenant.ID
    }

    const response: any = await apiRequest(
      {
        action: UtilsConst.HTTPAction.PUT,
        url: invitesV1ResendV1Url,
      },
      context,
      '',
      `resending invite to user`,
      StoreConst.StoreHelper.loadingMutationName,
      {
        [UtilsConst.RequestHeaders.CustomHeaderKeyTenantId]: tenantId,
      },
      (context: any, error: any, errorMsg: string) => {
        result.isSuccessful = false
        result.error = error

        if (error.response) {
          result.status = error.response.status
        }

        if (result.error == null) {
          result.error = {}
        }
        result.error.inviteId = payload.inviteId

        consoleLog(`Resending invite (Invite ID: ${payload.inviteId}) to user failed, error: ${JSON.stringify(error.response)}`)

        context.commit(StoreConst.StoreHelper.SetApiErrorMutationName, `Error happened when ${errorMsg}. ${error.response.data.message}`, {
          root: true,
        })
        context.commit(StoreConst.StoreHelper.loadingMutationName, false, { root: true })
        context.commit(StoreConst.StoreHelper.loadingModalMutationName, false, { root: true })
      }
    )

    if (response) {
      result.isSuccessful = true
      result.status = 200
      result.data = response
    }

    return result
  },
}
